import * as React from "react";

import "./agent-select.scss";

import {cs}                    from "@Common/react/chain-services";
import {consumeContext}        from "@Common/react/context";
import {fragments}             from "@Common/react/fragments";
import {Invoke}                from "@Common/react/invoke";
import {keyed}                 from "@Common/react/keyed";
import {UseState}              from "@Common/react/use-state";
import {SearchableMultiSelect} from "@Common/ui-components/searchable-multi-select/searchable-multi-select";
import {sortMulti}             from "@Common/utils/collections";
import {chain}                 from "@Common/utils/fs";

export const AgentSelect = ({branches, getAgentList, selectedAgents}) => cs(
    consumeContext("apis"),
    consumeContext("userLevels"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["loading", ({}, next) => UseState({initValue: false, next})],
    ({}, next) => fragments(
        next(),
        selectedAgents.value.map(({agent}) => !branches.some((b) => b.idBranch === agent.idBranch) && cs(
            keyed(agent.idAgent),
            () => Invoke({
                action: () => selectedAgents.change((list) => list.filter(({agent: agent1}) => agent1.idAgent !== agent.idAgent)),
            }),
        ))
    ),
    ({apis, isInternalUser, loading}) => (
        <div className="agent-select agent-select-5rd">
            {SearchableMultiSelect<any>({
                getSublabel: ({branch, agent}) => <>
                    <div>
                        Branch: {branch.branchName}
                    </div>
                    {isInternalUser && (
                        <div
                            xd-qa-type="dropdown_item"
                            xd-qa-name={`Agent ${agent.idAgent}`}
                        >
                            Internal ID: {agent.idAgent}
                        </div>
                    )}
                </>,
                list: branches
                    .map((branch) => chain(
                        getAgentList(branch.idBranch),
                        (_) => sortMulti(_, [
                            (agent) => agent["agentNameFirst"]?.toLowerCase(),
                            (agent) => agent["agentNameLast"]?.toLowerCase(),
                        ]),
                        (_) => _?.map((agent) => ({
                            branch,
                            agent,
                        })),
                    ))
                    .filter(v=>v)
                    .flat()
                ,
                disabled: branches.length === 0,
                loading: branches.find((b) => getAgentList(b.idBranch) == null),
                placeholder: "Please select user(s)",
                getLabel: ({agent}) => getAgentFullName(agent),
                onSelect: async ({agent}) => {
                    if(loading.value) return;
                    loading.onChange(true);
                    const data = await apis.next.adBudgets.getUserAdBudget({idBranch: agent.idBranch, search: agent.idAgent})
                    selectedAgents.change((agents) => [
                        ...agents,
                        {agent, allow: data.status, amount: data.amount},
                    ]);
                    loading.onChange(false);
                },
                onSelectAll: async () => {
                    if(loading.value) return;
                    loading.onChange(true);
                    if (selectedAgents.value.length !== 0) selectedAgents.change(() => []);
                    else {
                        const agentList = branches.map((branch) => getAgentList(branch.idBranch)).flat()
                        const data = await agentList.map(async (agent) => {
                            return apis.next.adBudgets.getUserAdBudget({idBranch: agent.idBranch, search: agent.idAgent});
                        });
                        const data1 = await Promise.all(data);
                        data1.map((data) => {
                            selectedAgents.change((agents) => [
                                ...agents,
                                {agent: data, allow: data.status, amount: data.amount},
                            ]);
                        })
                    }
                    loading.onChange(false);
                },
                onRemove: async ({agent}) => {
                    selectedAgents.change((agents) => agents.filter(({agent: agent1}) => agent1.idAgent !== agent.idAgent));
                },
                isSelected: ({agent}) => selectedAgents.value.some(({agent: v}) => v.idAgent === agent.idAgent),
                getXdQaName: ({agent}) => agent.idAgent,

                // className: "office",
                searchLabel: "Search a User",
                xdQaName: "Agent",
                scrollCloses: false,
            })}

            {selectedAgents.value?.length > 0 && (
                <div className="clear-selection">
                    <a
                        xd-qa-type="button"
                        xd-qa-name="Clear User Selection"
                        onClick={() => {
                            selectedAgents.onChange([]);
                            close();
                        }}
                    >
                        Clear ({selectedAgents.value.length})
                    </a>
                </div>
            )}
        </div>
    ),
);

const getAgentFullName = (agent) => [agent["agentNameFirst"], agent["agentNameLast"]].filter(v=>v).join(" ");
